import { Injectable } from '@angular/core';
import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import moment from 'moment-timezone';

@Injectable({ providedIn: 'root' })
@EasyDebugDecorator
export class DateService {
  constructor() {}

  dateToFormatFr(input?: string | number | moment.Moment | Date): moment.Moment {
    let output: moment.Moment = this.dateToMoment(); // today by default
    if (!!input) {
      output = this.dateToMoment(input);
      if (typeof input === 'string') {
        output = this.dateToMoment(input);
        if (input.includes('/')) {
          console.error('input string', input);
        }
      } else if (typeof input === 'number') {
        output = this.dateToMoment(input);
      } else if (typeof input === 'object') {
        if (
          !moment.isMoment(input) &&
          !!(input as Date).getFullYear &&
          !!(input as Date).getMonth &&
          !!(input as Date).getDate
        ) {
          const dateObj = input as Date;
          const year: number = dateObj.getFullYear();
          const month: string =
            dateObj.getMonth() + 1 < 10 ? '0' + (dateObj.getMonth() + 1) : (dateObj.getMonth() + 1).toString();
          const day: string = dateObj.getDate() < 10 ? '0' + dateObj.getDate() : dateObj.getDate().toString();
          const hours: string = dateObj.getHours() < 10 ? '0' + dateObj.getHours() : dateObj.getHours().toString();
          const minutes: string =
            dateObj.getMinutes() < 10 ? '0' + dateObj.getMinutes() : dateObj.getMinutes().toString();
          const str: string = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':00';
          output = this.dateToMoment(str);
        } else {
          output = this.dateToMoment(input);
        }
      }
    }
    if (!output.isValid()) {
      console.log('-------------------');
      console.error('dateToFormatFr input', input, typeof input);
      console.error('dateToFormatFr output', output, output.toString(), output.isValid());
      console.error('-------------------');
    }
    return output;
  }

  dateToMoment(input?: string | number | Date | moment.Moment): moment.Moment {
    const zone: string = 'Europe/Paris';
    moment.tz.setDefault(zone);
    moment.locale('fr');
    if (!!input) {
      return moment(input).tz(zone);
    }
    return moment().tz(zone);
  }
}
